module.exports = __webpack_public_path__ + "static/media/ESTJ.8f04f05a.png";